var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.dynamicElementName,_vm._b({tag:"component",staticClass:"st-list-item",class:[{
        selectable: _vm.selectable,
        hoverable: _vm.hoverable,
        disabled: _vm.disabled,
        button: _vm.dynamicElementName === 'button'
    }, _vm.$attrs.class],attrs:{"type":_vm.dynamicElementName === 'button' ? 'button' : undefined},on:{"click":_vm.onClick,"contextmenu":function($event){return _vm.$emit('contextmenu', $event)}}},'component',_vm.$attrs,false),[_c('div',{staticClass:"left"},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',[_c('div',{staticClass:"middle"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._t("right")],2)]),_vm._v(" "),_c('hr')])])
}
var staticRenderFns = []

export { render, staticRenderFns }